import axios from 'axios';
import BackendClient from '../backend-client';
import News, { modelFactory } from './model';

function formatCgesNews(data) {
  const { anuncios } = data.data;

  return anuncios.map((x) => ({
    name: x.titulo,
    id: x.id,
    summary: x.titulo,
    subject: x.titulo,
    text: x.titulo,
    zinfo_usuariofinal: x.contenidoUsuarioFinal,
    resolution: null,
    bussinessType: 'news',
    type: 'news',
    isNotifications: false,
  }));
}

export default class NewsClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  list = async (start, size, filters = {}, sort) => {
    const where = ['ACTIVE_STATE in (0, 2)'];

    if (typeof filters.primaryIndex === 'number') {
      where.push(`PRIMARY_INDEX=${filters.primaryIndex}`);
    }

    if (typeof filters.status === 'string') {
      where.push(`STATUS_ID in ${filters.status}`);
    }
    const response = await this.request('get')(
      {
        BackEnd: 1,
        filter: where.join(' AND '),
        sort,
        start,
        size,
      },
    );

    const newList = response.data.collection_message.message.map((x) => (
      {
        name: x['@COMMON_NAME'],
        id: x['@id'],
        ratingAverage: x.avg_rating,
        creationDate: x.creation_date,
        templateId: x.doc_template_id,
        hits: x.hits,
        pGroupId: x.pgroup_id,
        statusId: x.status_id,
        summary: x.summary,
        subject: x['@COMMON_NAME'],
        text: x['@COMMON_NAME'],
        zinfo_usuariofinal: x.zinfo_usuariofinal,
        resolution: x.resolution,
        bussinessType: 'news',
        type: 'news',
        isNotifications: false,
      }
    ));

    return {
      count: response.data.collection_message['@COUNT'],
      list: newList,
      start: response.data.collection_message['@START'],
      total: response.data.collection_message['@TOTAL_COUNT'],
    };
  }

  get = (id) => {
    const cancelToken = axios.CancelToken.source();
    const req = this.request('get', id)(null, {
      headers: {
        'x-obj-attrs': 'SUMMARY,RESOLUTION',
      },
      cancelToken: cancelToken.token,
    });
    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind(this);
    return req;
  }

  getCgesNews = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: '/news' },
      );
      const res = formatCgesNews(response);
      return res;
    } catch (error) {
      return error.response;
    }
  }
}

export {
  News,
};
